import React, { useState, useEffect } from 'react';

import { useForm } from 'react-hook-form';
import DropLeftIcon from '../../assets/drop_left_icon.png';
import DropRightIcon from '../../assets/drop_right_icon.png';
import TrashIcon from '../../assets/trash2_icon.png';
import {
    GlobalContainer,
    ContentContainer,
    ContentContainerBlock,
    ContentContainer1,
    ContentContainer4,
    ContentContainer10,
    ContentContainer11,
    ContentContainer12,
    ContentContainer13,
    ContentContainer14,
    ContentContainer15,
    InputContainer2,
    Title,
    TitleContainer,
    ContentContainerButtons,
    SelectContainer,
    SelectContainerMarginLeft,
    PaginationContainer,
    SelectPagesContainer,
    Mandatory
} from './styles';
import Select, { components } from 'react-select';
import ModalCancel from '../Modal/Cancel/index';
import ModalConfirm from '../Modal/Confirm/index';
import DropDownIcon from '../../assets/drop_down_icon.png';
import DropUpIcon from '../../assets/drop_up_icon.png';
import FailIcon from '../../assets/fail_icon.png';
import ExclamationIcon from '../../assets/icon_exclamation.png'
import { formatarCEP, cpfMask, isCpfValid, formatDate, removeInputMask } from '../../utils';
import ModalError from '../Modal/Error';
import ModalSuccess from '../Messages/Success/index';

export default function UnitElement(props) {
    const [rangePagesOptions] = useState([
        { value: "10", label: "10" },
        { value: "20", label: "20" },
        { value: "30", label: "30" }
    ]);
    const [defaultFormValues, setDefaultFormValues] = useState({
        organCode: "",
        unitCode: "",
        unitName: "",
        zipcode: "",
        state: "",
        municipalityCode: "",
        street: "",
        number: "" ,   
        addressComplement: "",
        neighborhood: "",
        enableCitizenOrAttorneyFingerprintVerify: false,
		enableAuthorizedCertificateLoginOnly: false,
        mobileServiceUnit: false
    });
    const [cpf, setCpf] = useState("");
    const [municipalityComboDisabled, setMunicipalityComboDisabled] = useState(true);
    const { handleSubmit } = useForm({ defaultFormValues });
    const [showErroUnitName, setShowErroUnitName] = useState(false);
    const [showErroZipcode, setShowErroZipcode] = useState(false);
    const [showInvalidErroZipcode, setShowInvalidErroZipcode] = useState(false);
    const [showErroStreet, setShowErroStreet] = useState(false);
    const [showErroState, setShowErroState] = useState(false);
    const [showErroMunicipality, setShowErroMunicipality] = useState(false);
    const [showErroNeighborhood, setShowErroNeighborhood] = useState(false);
    const [showErroCpf, setShowErroCpf] = useState(false);
    const [showInvalidErroCpf, setShowInvalidErroCpf] = useState(false);
    const [showDisableCitizenOrAttorneyFingerprintVerifyWarning, setShowDisableCitizenOrAttorneyFingerprintVerifyWarning] = useState(false);
    const [showDisableAuthorizedCertificateLoginOnlyWarning, setShowDisableAuthorizedCertificateLoginOnlyWarning] = useState(false);
    const [municipalityOptions, setMunicipalityOptions] = useState([]);
    const SelecPageStyles = {
        control: (defaultStyles, state) => ({
            ...defaultStyles,
            borderWidth: 0,
            borderColor: state.isFocused ? '#E60000' : '#888',
            '&:hover': {
                backgroundColor: '#C5D4EB',
            },
            marginTop: 15,
        }),
    }
    const { register } = useForm({ defaultFormValues })
    
    useEffect(() => {
            setDefaultFormValues(props.unit);   
            if (props.unit.municipalityCode) {
                setMunicipalityComboDisabled(true);
            } else {
                setMunicipalityComboDisabled(false);
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.unit])

    useEffect(() =>{
        async function listaMunicipios(uf) {
            const requestOptions = {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : ""
                }),
                body: JSON.stringify({
                    cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",
                    uf: uf
                }),
            };
            
            await fetch(`${process.env.REACT_APP_API_URL}/gestao/orgao/listaMunicipios`, requestOptions).then(
                function(response) {
                if (response.ok) {
                    response.json().then(function(data) {

                        var municipios = [];
                        var obj = {};

                        data.forEach((h) => {
                            obj = {
                                value: h.CODIGO_MUNICIPIO,
                                label: h.NOME_MUNICIPIO
                            };

                            municipios.push(obj);
                        });

                        setMunicipalityOptions(municipios);
                    });
                }
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
            });
        }
        if (props.unit.state?.value) {
            listaMunicipios(props.unit.state?.value)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.unit.state])

    // ESTILIZACAO PARA O SELECT ======================================================
    const SelecStyles = {
        control: (defaultStyles, state) => ({
            ...defaultStyles,
            borderWidth: state.isFocused ? 2.5 : 1,
            borderColor: state.isFocused ? '#E60000' : '#888',
            '&:hover': {
                backgroundColor: '#C5D4EB',
            },
            marginTop: 6,
        }),
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            fontSize: 13.5,
            fontWeight: 355,
            marginLeft: 7,
            fontStyle: 'italic',
        }),
    }

    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                {props.selectProps.menuIsOpen
                    ? <img src={DropUpIcon} alt="upicon" />
                    : <img src={DropDownIcon} alt="downicon" />
                }
            </components.DropdownIndicator>
        );
    };

    const IndicatorSeparator = ({ innerProps }) => <span style={{}} {...innerProps} />;

    const [isModalCancelVisible, setModalCancelVisible] = useState(false);

    const isZipCodeValid = (zipCode) => {
        const normalizedZipCode = zipCode && zipCode.replace(/\D/g, '')
        if (!normalizedZipCode || !/^[0-9]{8}$/.test(normalizedZipCode)) {
            return false
        }
        return true
    }

    const isAllFieldsValidated = () => {
        if (!defaultFormValues?.unitName?.trim()) {
            setShowErroUnitName(true);
            window.scrollTo(0, 0);
            return false;
        }
        if (!(defaultFormValues?.zipcode && defaultFormValues?.zipcode?.trim())) {
            setShowErroZipcode(true);
            window.scrollTo(0, 0);
            return false;
        }
        if (!isZipCodeValid(defaultFormValues?.zipcode)) {
            setShowInvalidErroZipcode(true);
            window.scrollTo(0, 0);
            return false;
        }
        if (!(defaultFormValues?.state)) {
            setShowErroState(true);
            window.scrollTo(0, 0);
            return false;
        }
        if (!(defaultFormValues?.municipalityCode)) {
            setShowErroMunicipality(true);
            window.scrollTo(0, 0);
            return false;
        }
        if (!(defaultFormValues?.street && defaultFormValues?.street?.trim())) {
            setShowErroStreet(true);
            window.scrollTo(0, 0);
            return false;
        }
        if (!(defaultFormValues?.neighborhood && defaultFormValues?.neighborhood?.trim())) {
            setShowErroNeighborhood(true);
            window.scrollTo(0, 0);
            return false;
        }
        
        return true;
    }

    const resetAddressErros = () => {
        setShowErroZipcode(false);
        setShowInvalidErroZipcode(false);
        setShowErroStreet(false);
        setShowErroState(false);
        setShowErroMunicipality(false);
        setShowErroNeighborhood(false);
    }
    // ================================================================================

    return (
        <>
                <>
                    <ModalCancel
                        id="modalcancelalert"
                        appear={isModalCancelVisible}
                        text={"Tem certeza que deseja cancelar a operação?"}
                        actionButton1={() => setModalCancelVisible(false)}
                        actionButton2={() => props.history.push(props.buttonCancelRoute)}
                    />

                    <ModalError
                        id="modalconfirmalert"
                        appear={props.modalError}
                        text={props.messageError}
                        actionButton2={() => {
                                setDefaultFormValues({ ...defaultFormValues, zipcode: "", street: "", number: "", addressComplement: "", neighborhood: "", state: "", municipalityCode: "" })
                                props.setModalError(false)
                            }
                        }
                        history={props.history}
                        location={props.location}
                    />

                    <ModalConfirm
                        id="modalDisableCitizenOrAttorneyFingerprintVerifyWarning"
                        appear={showDisableCitizenOrAttorneyFingerprintVerifyWarning}
                        title="Atenção"
                        text={
                            defaultFormValues.enableCitizenOrAttorneyFingerprintVerify ?
                                "Ao <b>desabilitar</b> esta opção, não será pedida a validação da biometria das digitais do cidadão ou do seu procurador. Tem certeza que deseja continuar?"
                                :
                                "Ao <b>habilitar</b> esta opção, será pedida a validação da biometria das digitais do cidadão ou do seu procurador. Tem certeza que deseja continuar?"
                            }
                        textButton1="Não"
                        actionButton1={() => setShowDisableCitizenOrAttorneyFingerprintVerifyWarning(false)}
                        textButton2="Sim"
                        actionButton2={(e) => {
                                    let valor = !defaultFormValues.enableCitizenOrAttorneyFingerprintVerify;
                                    setDefaultFormValues({ ...defaultFormValues, enableCitizenOrAttorneyFingerprintVerify: valor })
                                    props.setUnit({ ...props.unit, enableCitizenOrAttorneyFingerprintVerify: valor });
                                    setShowDisableCitizenOrAttorneyFingerprintVerifyWarning(false)
                                }}
                    />
                    <ModalConfirm
                        id="modalDisableAuthorizedCertificateLoginOnlyWarning"
                        appear={showDisableAuthorizedCertificateLoginOnlyWarning}
                        title="Atenção"
                        text={
                            defaultFormValues.enableAuthorizedCertificateLoginOnly ?
                                "Ao <b>desmarcar</b> esta opção, não seja exigido login por meio de certificado digital autorizado. Tem certeza que deseja continuar?"
                                :
                                "Ao <b>marcar</b> esta opção, será exigido login por meio de certificado digital autorizado. Tem certeza que deseja continuar?"
                            }
                        textButton1="Não"
                        actionButton1={() => setShowDisableAuthorizedCertificateLoginOnlyWarning(false)}
                        textButton2="Sim"
                        actionButton2={(e) => {
                                    setDefaultFormValues({ ...defaultFormValues, enableAuthorizedCertificateLoginOnly: !defaultFormValues.enableAuthorizedCertificateLoginOnly })
                                    setShowDisableAuthorizedCertificateLoginOnlyWarning(false)
                                }}
                    />

                    <GlobalContainer>
                        {props.fromSuccessMsg &&
                            <ModalSuccess text={props.fromSuccessMsg}/>
                        }
                        <form onSubmit={handleSubmit(() => { if (isAllFieldsValidated()) props.onSubmitData(defaultFormValues); } ) }>
                            <ContentContainer>
                                <ContentContainer1>
                                    <TitleContainer>
                                        <Title> {props.pageTitle} </Title>
                                    </TitleContainer>
                                    <ContentContainer11>
                                        <div className="br-input">
                                            <label htmlFor="unitName">Nome da unidade<Mandatory>*</Mandatory></label>
                                            <input
                                                id="unitName-input"
                                                name="unitName"
                                                type="text"
                                                data-input="data-input"
                                                placeholder="Informe nome que facilite a identificação da unidade pelo cidadão"
                                                defaultValue={props.unit.unitName}
                                                onInput={e => { setDefaultFormValues({ ...defaultFormValues, unitName: e.target.value }); props.setUnit({ ...props.unit, unitName: e.target.value}); setShowErroUnitName(false); }} //Foi usado o onInput ao invés do onChange para corrigir um bug que ocorre quando se seleciona o dado e o apaga usando o botão "Del"
                                                style={{
                                                    "padding": "0px 7px 0px",
                                                    "fontSize": "14px",
                                                    "fontWeight": "normal",
                                                    "color": "#333333"
                                                }}
                                            />
                                            {showErroUnitName &&
                                                <span className="feedback danger" role="alert">
                                                    <i className="fas fa-times-circle" aria-hidden="true">
                                                        <img
                                                            src={FailIcon}
                                                            style={{ paddingBottom: '5px' }}
                                                            alt="failicon"
                                                        />
                                                    </i>
                                                    Este campo é obrigatório.
                                                </span>}
                                        </div>
                                    </ContentContainer11>
                                    <ContentContainer11>
                                        <InputContainer2>
                                            <input
                                                name='mobileServiceUnit'
                                                id='mobileServiceUnit'
                                                type='checkbox'
                                                checked={defaultFormValues.mobileServiceUnit}                                                 
                                                ref={register({
                                                    required: false,
                                                })}
                                                onChange={(event) => {
                                                        let valor = !defaultFormValues.mobileServiceUnit;
                                                        setDefaultFormValues({ ...defaultFormValues, mobileServiceUnit: valor });
                                                        props.setUnit({ ...props.unit, mobileServiceUnit: valor });
                                                    }}
                                            />
                                            <label htmlFor='mobileServiceUnit'>Unidade de Atendimento Móvel/Itinerante<span style={{"fontSize": "80%", "fontWeight": "normal"}}> (Marque esta opção caso a unidade não possua espaço físico fixo e seja utilizada para atendimentos móveis ou itinerantes.)</span></label>
                                        </InputContainer2>                                            
                                    </ContentContainer11>
                                    
                                    <label>Endereço <span style={{"fontSize": "80%", "fontWeight": "normal"}}>(Informe o endereço completo para facilitar a identificação da unidade pelo cidadão)</span></label>
                                    <ContentContainer12>
                                        <ContentContainer13>
                                            <ContentContainer10>
                                                <span role="alert">
                                                    <i className="fas fa-circle-exclamation mr-1" aria-hidden="true">
                                                        <img
                                                            src={ExclamationIcon}
                                                            style={{ paddingBottom: '5px' }}
                                                            alt="exclamationIcon"
                                                        />
                                                    </i>
                                                    Se a unidade de atendimento for móvel/itinerante, informe o endereço do local onde o cidadão poderá obter informações sobre os locais e horários de atendimento.
                                                </span>                                                
                                            </ContentContainer10>
                                            <ContentContainer14>
                                                <div className="br-input">
                                                    <div style={{"width": "850px"}}>
                                                        <label htmlFor="zipcode">CEP<Mandatory>*</Mandatory> 
                                                            <span style={{"fontSize": "80%", "fontWeight": "normal"}}> Preencha com o CEP correspondente ao endereço específico da unidade (rua e bairro), conforme a base oficial e atualizada dos Correios. </span>
                                                            <a style={{"paddingLeft": "5px", "fontSize": "70%", "fontWeight": "700"}} href="http://www.buscacep.correios.com.br/sistemas/buscacep/" target="_blank" rel="noopener noreferrer">Consulte aqui</a>
                                                        </label>
                                                    </div>   
                                                    <input
                                                        id="zipcode-input"
                                                        name="zipcode"
                                                        type="text"
                                                        data-input="data-input"
                                                        placeholder="Digite o CEP"
                                                        defaultValue={formatarCEP(props.unit.zipcode)}
                                                        value={formatarCEP(defaultFormValues.zipcode)}
                                                        onInput={e => { setDefaultFormValues({ ...defaultFormValues, zipcode: e.target.value, street: "", number: "", addressComplement: "", neighborhood: "", state: "", municipalityCode: "" }); resetAddressErros(); if (isZipCodeValid(e.target.value)) { props.pesquisaCEP(e.target.value)} }} //Foi usado o onInput ao invés do onChange para corrigir um bug que ocorre quando se seleciona o dado e o apaga usando o botão "Del"
                                                        style={{
                                                            "padding": "0px 7px 0px",
                                                            "fontSize": "14px",
                                                            "fontWeight": "normal",
                                                            "color": "#333333"
                                                        }}
                                                    />
                                                    {props.loadingAdd &&
                                                        <span style={{"fontSize": "90%", "fontWeight": "normal", "color": "green"}}>Consultando o CEP. Aguarde...</span>
                                                    }                                                    
                                                    {showErroZipcode &&
                                                        <span className="feedback danger" role="alert">
                                                            <i className="fas fa-times-circle" aria-hidden="true">
                                                                <img
                                                                    src={FailIcon}
                                                                    style={{ paddingBottom: '5px' }}
                                                                    alt="failicon"
                                                                />
                                                            </i>
                                                            Este campo é obrigatório.
                                                        </span>}
                                                    {showInvalidErroZipcode &&
                                                        <span className="feedback danger" role="alert">
                                                            <i className="fas fa-times-circle" aria-hidden="true">
                                                                <img
                                                                    src={FailIcon}
                                                                    style={{ paddingBottom: '5px' }}
                                                                    alt="failicon"
                                                                />
                                                            </i>
                                                            CEP Inválido
                                                        </span>}
                                                </div>
                                            </ContentContainer14>
                                            <ContentContainer15>
                                                <ContentContainerBlock>
                                                    <div className="br-input" style={{"width": "80%"}}>
                                                        <label htmlFor="street">Logradouro (Rua/Avenida)<Mandatory>*</Mandatory></label>
                                                        <input
                                                            id="street-input"
                                                            name="street"
                                                            type="text"
                                                            data-input="data-input"
                                                            placeholder="Rua/Avenida"
                                                            value={defaultFormValues.street}
                                                            onInput={e => { setDefaultFormValues({ ...defaultFormValues, street: e.target.value }); setShowErroStreet(false)}} //Foi usado o onInput ao invés do onChange para corrigir um bug que ocorre quando se seleciona o dado e o apaga usando o botão "Del"
                                                            style={{
                                                                "padding": "0px 7px 0px",
                                                                "fontSize": "14px",
                                                                "fontWeight": "normal",
                                                                "color": "#333333"
                                                            }}
                                                        />
                                                        {showErroStreet &&
                                                            <span className="feedback danger" role="alert">
                                                                <i className="fas fa-times-circle" aria-hidden="true">
                                                                    <img
                                                                        src={FailIcon}
                                                                        style={{ paddingBottom: '5px' }}
                                                                        alt="failicon"
                                                                    />
                                                                </i>
                                                                Este campo é obrigatório.
                                                            </span>}
                                                    </div>
                                                    <div className="br-input" style={{"paddingLeft": "20px","width": "20%"}}>
                                                        <label htmlFor="number">Número</label>
                                                        <input
                                                            id="number-input"
                                                            name="number"
                                                            type="text"
                                                            data-input="data-input"
                                                            placeholder="Número"
                                                            value={defaultFormValues.number}
                                                            onInput={e => {setDefaultFormValues({ ...defaultFormValues, number: e.target.value });}} //Foi usado o onInput ao invés do onChange para corrigir um bug que ocorre quando se seleciona o dado e o apaga usando o botão "Del"
                                                            style={{
                                                                "padding": "0px 7px 0px",
                                                                "fontSize": "14px",
                                                                "fontWeight": "normal",
                                                                "color": "#333333"
                                                            }}
                                                        />
                                                    </div>
                                                </ContentContainerBlock>                                                
                                            </ContentContainer15>
                                            <ContentContainer15>
                                                <ContentContainerBlock>
                                                    <div className="br-input" style={{"width": "70%"}}>
                                                        <label htmlFor="addressComplement">Complemento</label>
                                                        <input
                                                            id="addressComplement-input"
                                                            name="addressComplement"
                                                            type="text"
                                                            data-input="data-input"
                                                            placeholder="Complemento"
                                                            value={defaultFormValues.addressComplement}
                                                            onInput={e => { setDefaultFormValues({ ...defaultFormValues, addressComplement: e.target.value }); }} //Foi usado o onInput ao invés do onChange para corrigir um bug que ocorre quando se seleciona o dado e o apaga usando o botão "Del"
                                                            style={{
                                                                "padding": "0px 7px 0px",
                                                                "fontSize": "14px",
                                                                "fontWeight": "normal",
                                                                "color": "#333333"
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="br-input" style={{"paddingLeft": "20px","width": "40%"}}>
                                                        <label htmlFor="neighborhood">Bairro<Mandatory>*</Mandatory></label>
                                                        <input
                                                            id="neighborhood-input"
                                                            name="neighborhood"
                                                            type="text"
                                                            data-input="data-input"
                                                            placeholder="Bairro"
                                                            value={defaultFormValues.neighborhood}
                                                            onInput={e => { setDefaultFormValues({ ...defaultFormValues, neighborhood: e.target.value }); setShowErroNeighborhood(false);}} //Foi usado o onInput ao invés do onChange para corrigir um bug que ocorre quando se seleciona o dado e o apaga usando o botão "Del"
                                                            style={{
                                                                "padding": "0px 7px 0px",
                                                                "fontSize": "14px",
                                                                "fontWeight": "normal",
                                                                "color": "#333333"
                                                            }}
                                                        />
                                                        {showErroNeighborhood &&
                                                            <span className="feedback danger" role="alert">
                                                                <i className="fas fa-times-circle" aria-hidden="true">
                                                                    <img
                                                                        src={FailIcon}
                                                                        style={{ paddingBottom: '5px' }}
                                                                        alt="failicon"
                                                                    />
                                                                </i>
                                                                Este campo é obrigatório.
                                                            </span>}
                                                    </div>
                                                </ContentContainerBlock>                                                
                                            </ContentContainer15>
                                            <ContentContainer15>
                                                <ContentContainerBlock>
                                                    <SelectContainer>
                                                        <label>Estado<Mandatory>*</Mandatory></label>
                                                        <Select
                                                            isDisabled={true}
                                                            onInput={(value) => {
                                                                setDefaultFormValues({ ...defaultFormValues, state: { value: value.value, label: value.label } }); //Foi usado o onInput ao invés do onChange para corrigir um bug que ocorre quando se seleciona o dado e o apaga usando o botão "Del"
                                                                if (value) {
                                                                    setShowErroState(false); //Limpa erro
                                                                }
                                                            }}
                                                            options={props.stateOptions}
                                                            value = {defaultFormValues.state}
                                                            placeholder="Selecione o estado"
                                                            styles={SelecStyles}
                                                            theme={theme => ({
                                                                ...theme,
                                                                borderRadius: 6,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: '#CCCCCC',
                                                                    primary: '#1351B4'
                                                                },
                                                            })}
                                                            components={
                                                                {
                                                                    DropdownIndicator,
                                                                    IndicatorSeparator
                                                                }
                                                            }
                                                        />
                                                    </SelectContainer>
                                                    
                                                    <SelectContainerMarginLeft>
                                                        <label>Município<Mandatory>*</Mandatory></label>                                                   
                                                        <Select
                                                            isDisabled={municipalityComboDisabled}
                                                            onChange={(value) => {
                                                                setDefaultFormValues({ ...defaultFormValues, municipalityCode: value.value });
                                                                if (value) {
                                                                    setShowErroMunicipality(false); //Limpa erro
                                                                }
                                                            }}
                                                            options={municipalityOptions}
                                                            value={ (defaultFormValues.municipalityCode ? municipalityOptions.find(obj => obj.value === defaultFormValues.municipalityCode) : null)}
                                                            placeholder="Selecione o município"
                                                            styles={SelecStyles}
                                                            theme={theme => ({
                                                                ...theme,
                                                                borderRadius: 6,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: '#CCCCCC',
                                                                    primary: '#1351B4'
                                                                },
                                                            })}
                                                            components={
                                                                {
                                                                    DropdownIndicator,
                                                                    IndicatorSeparator
                                                                }
                                                            }
                                                        />
                                                        {showErroMunicipality &&
                                                        <span className="feedback danger" role="alert" id="cpfoperator">
                                                            <i className="fas fa-times-circle" aria-hidden="true">
                                                                <img
                                                                    src={FailIcon}
                                                                    style={{ paddingBottom: '5px' }}
                                                                    alt="failicon"
                                                                />
                                                            </i>
                                                            Este campo é obrigatório.
                                                        </span>}                                                                                                 
                                                    </SelectContainerMarginLeft>
                                                    
                                                    {showErroState &&
                                                        <span className="feedback danger" role="alert" id="cpfoperator">
                                                            <i className="fas fa-times-circle" aria-hidden="true">
                                                                <img
                                                                    src={FailIcon}
                                                                    style={{ paddingBottom: '5px' }}
                                                                    alt="failicon"
                                                                />
                                                            </i>
                                                            Este campo é obrigatório.
                                                        </span>}
                                                </ContentContainerBlock>                                                
                                            </ContentContainer15>                     
                                        </ContentContainer13>
                                    </ContentContainer12>

                                    <label>Horário de atendimento ao público <span style={{"fontSize": "80%", "fontWeight": "normal"}}>(Essa informação será utilizada exclusivamente para fins de comunicação ao cidadão e não será utilizada para controle de funcionamento do sistema)</span></label>
                                    <ContentContainer12>
                                        <ContentContainer13>
                                            <div className="br-input">
                                                <label htmlFor="unitOpeningHoursDescription">Informe os dias e horários em que a unidade realiza atendimento ao público</label>
                                                <input
                                                    id="unitOpeningHoursDescription-input"
                                                    name="unitOpeningHoursDescription"
                                                    type="text"
                                                    data-input="data-input"
                                                    placeholder="Escreva aqui uma breve descrição do que deve ser informado ao cidadão sobre o horário de funcionamento da unidade."
                                                    defaultValue={props.unit.unitOpeningHoursDescription}
                                                    onInput={e => { setDefaultFormValues({ ...defaultFormValues, unitOpeningHoursDescription: e.target.value }); props.setUnit({ ...props.unit, unitOpeningHoursDescription: e.target.value}); }} //Foi usado o onInput ao invés do onChange para corrigir um bug que ocorre quando se seleciona o dado e o apaga usando o botão "Del"
                                                    style={{
                                                        "padding": "0px 7px 0px",
                                                        "fontSize": "14px",
                                                        "fontWeight": "normal",
                                                        "color": "#333333"
                                                    }}
                                                />
                                            </div>
                                        </ContentContainer13>
                                    </ContentContainer12>
                                    
                                    <label>Segurança nos atendimentos ao cidadão <span style={{"fontSize": "80%", "fontWeight": "normal"}}>(Informe os procedimentos de segurança que os atendentes ou gestores regionais lotados nesta unidade devem seguir durante os atendimentos)</span></label>
                                    <ContentContainer12>
                                        <ContentContainer13>
                                            <InputContainer2>
                                                <input
                                                    name='enableCitizenOrAttorneyFingerprintVerify'
                                                    id='enableCitizenOrAttorneyFingerprintVerify'
                                                    type='checkbox'
                                                    checked={defaultFormValues.enableCitizenOrAttorneyFingerprintVerify}                                                 
                                                    ref={register({
                                                        required: false,
                                                    })}
                                                    onChange={(event) => {
                                                            setShowDisableCitizenOrAttorneyFingerprintVerifyWarning(true);
                                                     }}
                                                />
                                                <label htmlFor='enableCitizenOrAttorneyFingerprintVerify'>Habilitar a verificação biométrica das digitais do cidadão dono da conta gov.br ou do seu representante (procurador).</label>
                                            </InputContainer2>    
                                            <br></br>
                                            <InputContainer2>
                                                <input
                                                    name='enableAuthorizedCertificateLoginOnly'
                                                    id='enableAuthorizedCertificateLoginOnly'
                                                    type='checkbox'
                                                    checked={defaultFormValues.enableAuthorizedCertificateLoginOnly}                                                 
                                                    ref={register({
                                                        required: false,
                                                    })}
                                                    onChange={(event) => {
                                                            setShowDisableAuthorizedCertificateLoginOnlyWarning(true);
                                                     }}
                                                />
                                                <label htmlFor='enableAuthorizedCertificateLoginOnly'>Esta unidade deve ser acessada apenas por usuários que estiverem logados por meio de certificado digital autorizado.</label>
                                            </InputContainer2>                                        
                                        </ContentContainer13>
                                    </ContentContainer12>
                                    <label>Gestores regionais vinculados</label>
                                    <ContentContainer12>
                                        <ContentContainer13>
                                            <ContentContainer15>
                                                <label style={{fontWeight:'normal'}}>Vincular Gestor Existente: Se o gestor já estiver cadastrado no sistema, digite o CPF e clique em <b>Vincular Gestor Regional</b></label>
                                                <br />
                                                <label style={{fontWeight:'normal'}}>Cadastrar Gestor: Se ainda não estiver cadastrado, clique em <b>+ Cadastrar Gestor Regional</b></label>
                                                <br /><br />
                                                <ContentContainerBlock>
                                                    <div className="br-input" style={{"width": "30%"}}>
                                                        <div>
                                                            <label htmlFor="cpf">CPF</label>
                                                        </div>                                                    
                                                        <input
                                                            id="cpf-input"
                                                            name="cpf"
                                                            type="text"
                                                            data-input="data-input"
                                                            placeholder="Digite somente números"
                                                            maxLength="14"
                                                            defaultValue=""
                                                            value={cpfMask(cpf)}
                                                            onInput={e => { setCpf(e.target.value); setShowErroCpf(false); setShowInvalidErroCpf(false); }} //Foi usado o onInput ao invés do onChange para corrigir um bug que ocorre quando se seleciona o dado e o apaga usando o botão "Del"
                                                            style={{
                                                                "padding": "0px 7px 0px",
                                                                "fontSize": "14px",
                                                                "fontWeight": "normal",
                                                                "color": "#333333"
                                                            }}
                                                        />
                                                        {showErroCpf &&
                                                            <span className="feedback danger" role="alert">
                                                                <i className="fas fa-times-circle" aria-hidden="true">
                                                                    <img
                                                                        src={FailIcon}
                                                                        style={{ paddingBottom: '5px' }}
                                                                        alt="failicon"
                                                                    />
                                                                </i>
                                                                Este campo é obrigatório.
                                                            </span>}
                                                        {showInvalidErroCpf &&
                                                            <span className="feedback danger" role="alert">
                                                                <i className="fas fa-times-circle" aria-hidden="true">
                                                                    <img
                                                                        src={FailIcon}
                                                                        style={{ paddingBottom: '5px' }}
                                                                        alt="failicon"
                                                                    />
                                                                </i>
                                                                CPF Inválido
                                                            </span>}
                                                    </div>
                                                    <div className="br-input" style={{"paddingLeft": "20px","width": "70%"}}>
                                                        <button id="bntIncluirVincular" className={"br-button primary "+(props.loadingIncludeGestor ? "loading" : "")} type="button"
                                                            onClick={() => {
                                                                if (props.loadingIncludeGestor) {
                                                                    return;
                                                                }
                                                                if (isCpfValid(cpf)) {                                                                     
                                                                    if (props.searchResult.filter(e => e.STATUS !== 'deleted' && e.CPF_USUARIO === removeInputMask(cpf)).length > 0) {  //Verifica se o gestor com estatus não deletado está na lista
                                                                        props.setModalError(true);
                                                                        props.setMessageError('Este gestor regional já se encontra incluído.');
                                                                    } else {
                                                                        let save = true;
                                                                        props.setSearchResult(props.searchResult.map(e => {  //Verificar se o gestor já se encontra na lista como "deletado". Em caso positivo, remover este status.
                                                                            if (e.STATUS === 'deleted' && e.CPF_USUARIO === removeInputMask(cpf)) {
                                                                                e.STATUS = 'undeleted'
                                                                                save = false;
                                                                            }
                                                                                return e;
                                                                            }
                                                                        ))
                                                                        if (save) { //Caso o gestor não esteja na lista, recupera o gestor no banco e o adiciona à lista
                                                                            props.onSubmitCPF(cpf)
                                                                        }
                                                                    }                                           
                                                                    document.getElementById("cpf-input").value = "";
                                                                    setCpf("");
                                                                } else {
                                                                    setShowInvalidErroCpf(true);
                                                                }
                                                            }}>
                                                            Vincular Gestor Regional
                                                        </button>
                                                        <button className={"br-button primary ml-5 "+(props.loadingIncludeGestor ? "loading" : "")} type="button"
                                                            onClick={() => props.history.push(props.buttonRegistrationRoute, {returnTo: props.returnTo, unit: defaultFormValues, userlist: props.searchResult})}>
                                                            + Cadastrar Gestor Regional
                                                        </button>
                                                    </div>
                                                </ContentContainerBlock>
                                            </ContentContainer15>
                                            <ContentContainer4>
                                                {!!(!(props.searchResult.length > 0)) && <>
                                                    <label style={{'color': 'red'}}>Não há gestores vinculados a esta unidade.</label>
                                                </>}
                                                {!!(props.searchResult && props.searchResult.length > 0) && <>
                                                    <label>{props.tableResultListTitle}</label>
                                                    <div className="br-table" data-search="data-search" data-selection="data-selection">
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col0" style={{ 'color': '#1351B4' }}></th>
                                                                    <th scope="col1" style={{ 'color': '#1351B4' }}> Nome completo </th>
                                                                    <th scope="col2" style={{ 'color': '#1351B4' }}> CPF </th>
                                                                    <th scope="col4" style={{ 'color': '#1351B4' }}> Data de Cadastro </th>
                                                                    <th scope="col5" style={{ 'color': '#1351B4' }}> Data de Expiração </th>
                                                                    <th scope="col6" style={{ 'color': '#1351B4' }}> Ações </th>
                                                                    <th scope="col99" style={{ 'color': '#1351B4' }}></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {props.searchResult.filter(e => e.STATUS !== 'deleted').map(result => (
                                                                    <tr key={result.ID_USUARIO_ORGAO}>
                                                                        <td> </td>
                                                                        <td> {result.NOME_USUARIO} </td>
                                                                        <td> { cpfMask(result.CPF_USUARIO) }</td>
                                                                        <td> { formatDate(result.DATA_INCLUSAO) } </td>
                                                                        <td> {result.DATA_CANCELAMENTO === null ? "-" : formatDate(result.DATA_CANCELAMENTO) } </td>
                                                                        <td style={{width: "100px"}}>                                                
                                                                            <img
                                                                                src={TrashIcon}
                                                                                alt="trashIcon"
                                                                                title="Remover"
                                                                                style={{
                                                                                    'cursor': 'pointer'
                                                                                }}
                                                                                onClick={() => {
                                                                                    props.setSearchResult(
                                                                                        (result.STATUS === 'new' ) ?
                                                                                        props.searchResult.filter(e => e.ID_USUARIO_ORGAO !== result.ID_USUARIO_ORGAO)
                                                                                        :
                                                                                        props.searchResult.map(e => {
                                                                                            if (e.ID_USUARIO_ORGAO === result.ID_USUARIO_ORGAO){
                                                                                                e.STATUS = 'deleted';
                                                                                            }
                                                                                            return e
                                                                                        })
                                                                                    );                                                                                                                                                                        
                                                                                }}
                                                                            />
                                                                        </td> 
                                                                        <td> </td>
                                                                    </tr>
                                                                )
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    <PaginationContainer>
                                                        <nav className="br-pagination" aria-label="Paginação de resultados" data-total="50" data-current="1" data-per-page="20">
                                                            <div className="pagination-per-page">
                                                                <label style={{ "fontWeight": "normal", "marginRight": "15px" }}> Exibir </label>
                                                                <SelectPagesContainer>
                                                                    <Select
                                                                        options={rangePagesOptions}
                                                                        defaultValue={{ value: "10", label: "10" }}
                                                                        value={props.rangePages}
                                                                        onChange={value => {
                                                                            if (props.searchResult.filter(e => e.STATUS === 'deleted' || e.STATUS === 'new').length > 0) {
                                                                                props.setModalError(true);
                                                                                props.setMessageError('Existem mudanças não salvas. Por favor, salve as mudanças antes de continuar.');
                                                                            } else {
                                                                                props.setRangePages(value)
                                                                                props.onChangePaginationConfig(value, props.page, true)
                                                                            }
                                                                        }}
                                                                        styles={SelecPageStyles}
                                                                        theme={theme => ({
                                                                            ...theme,
                                                                            borderRadius: 6,
                                                                            colors: {
                                                                                ...theme.colors,
                                                                                primary25: '#CCCCCC',
                                                                                primary: '#1351B4'
                                                                            },
                                                                        })}
                                                                        components={
                                                                            {
                                                                                DropdownIndicator,
                                                                                IndicatorSeparator
                                                                            }
                                                                        }
                                                                    />
                                                                </SelectPagesContainer>
                                                            </div>

                                                            <span className="br-divider d-none d-sm-block mx-3"></span>

                                                            <div className="pagination-information d-none d-sm-flex">
                                                                <span className="current"> {1 + ((Number(props.page.value) - 1) * Number(props.rangePages.value))} </span>&ndash;<span className="per-page"> {Number(props.page.value) * Number(props.rangePages.value)} </span>&nbsp;de&nbsp;<span className="total"> {props.totalFilter} </span>&nbsp;itens
                                                            </div>
                                                            <div className="pagination-go-to-page d-none d-sm-flex ml-auto">
                                                                <label style={{ "fontWeight": "normal", "marginRight": "15px" }}> Página </label>
                                                                <SelectPagesContainer>
                                                                    <Select
                                                                        options={props.pageOptions}
                                                                        defaultValue={{ value: "1", label: "1" }}
                                                                        value={props.page}
                                                                        onChange={value => {
                                                                            if (props.searchResult.filter(e => e.STATUS === 'deleted' || e.STATUS === 'new').length > 0) {
                                                                                props.setModalError(true);
                                                                                props.setMessageError('Existem mudanças não salvas. Por favor, salve as mudanças antes de continuar.');
                                                                            } else {
                                                                                props.setPage(value)
                                                                                props.onChangePaginationConfig(props.rangePages, value, false)
                                                                            }
                                                                        }}
                                                                        styles={SelecPageStyles}
                                                                        theme={theme => ({
                                                                            ...theme,
                                                                            borderRadius: 6,
                                                                            colors: {
                                                                                ...theme.colors,
                                                                                primary25: '#CCCCCC',
                                                                                primary: '#1351B4'
                                                                            },
                                                                        })}
                                                                        components={
                                                                            {
                                                                                DropdownIndicator,
                                                                                IndicatorSeparator
                                                                            }
                                                                        }
                                                                    />
                                                                </SelectPagesContainer>
                                                            </div>

                                                            <span className="br-divider d-none d-sm-block mx-3"></span>

                                                            <div className="pagination-arrows ml-auto ml-sm-0">
                                                                <button className="br-button circle" type="button" aria-label="Voltar página"
                                                                    style={{
                                                                        'opacity': Number(props.page.value) > 1 ? '' : '0.4',
                                                                        'pointerEvents': Number(props.page.value) > 1 ? '' : 'none'
                                                                    }}
                                                                    onClick={() => {
                                                                        if (props.searchResult.filter(e => e.STATUS === 'deleted' || e.STATUS === 'new').length > 0) {
                                                                            props.setModalError(true);
                                                                            props.setMessageError('Existem mudanças não salvas. Por favor, salve as mudanças antes de continuar.');
                                                                        } else {
                                                                            const new_page = {
                                                                                value: String(Number(props.page.value) - 1),
                                                                                label: String(Number(props.page.value) - 1)
                                                                            }
                                                                            props.setPage(new_page)
                                                                            props.onChangePaginationConfig(props.rangePages, new_page, false)
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="fas fa-angle-left" aria-hidden="true">
                                                                        <img
                                                                            src={DropLeftIcon}
                                                                            alt="leftIcon"
                                                                            style={{ "marginBottom": "6px" }}
                                                                        />
                                                                    </i>
                                                                </button>
                                                                <button className="br-button circle" type="button" aria-label="Avançar página"
                                                                    style={{
                                                                        'opacity': Number(props.page.value) < (Math.ceil(Number(props.totalFilter) / Number(props.rangePages.value))) ? '' : '0.4',
                                                                        'pointerEvents': Number(props.page.value) < (Math.ceil(Number(props.totalFilter) / Number(props.rangePages.value))) ? '' : 'none'
                                                                    }}
                                                                    onClick={() => {
                                                                        if (props.searchResult.filter(e => e.STATUS === 'deleted' || e.STATUS === 'new').length > 0) {
                                                                            props.setModalError(true);
                                                                            props.setMessageError('Existem mudanças não salvas. Por favor, salve as mudanças antes de continuar.');
                                                                        } else {
                                                                            const new_page = {
                                                                                value: String(Number(props.page.value) + 1),
                                                                                label: String(Number(props.page.value) + 1)
                                                                            }
                                                                            props.setPage(new_page)
                                                                            props.onChangePaginationConfig(props.rangePages, new_page, false)
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="fas fa-angle-right" aria-hidden="true">
                                                                        <img
                                                                            src={DropRightIcon}
                                                                            alt="rightIcon"
                                                                            style={{ "marginBottom": "6px" }}
                                                                        />
                                                                    </i>
                                                                </button>
                                                            </div>
                                                        </nav>
                                                    </PaginationContainer>
                                                </>}
                                            </ContentContainer4>
                                        </ContentContainer13>
                                    </ContentContainer12>









                                    {!!(props.onChangePaginationConfigAttendant) &&
                                    <>
                                        <label>Atendentes vinculados</label>
                                        <ContentContainer13>
                                            <ContentContainer4>
                                                {!!(!(props.searchResultAttendant.length > 0)) && <>
                                                    <label style={{'color': 'red'}}>Não há atendentes vinculados a esta unidade.</label>
                                                </>}
                                                {!!(props.searchResultAttendant && props.searchResultAttendant.length > 0) && <>
                                                    <label>{props.tableResultListTitle}</label>
                                                    <div className="br-table" data-search="data-search" data-selection="data-selection">
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col0" style={{ 'color': '#1351B4' }}></th>
                                                                    <th scope="col1" style={{ 'color': '#1351B4' }}> Nome completo </th>
                                                                    <th scope="col2" style={{ 'color': '#1351B4' }}> CPF </th>
                                                                    <th scope="col4" style={{ 'color': '#1351B4' }}> Data de Cadastro </th>
                                                                    <th scope="col5" style={{ 'color': '#1351B4' }}> Data de Expiração </th>
                                                                    <th scope="col99" style={{ 'color': '#1351B4' }}></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {props.searchResultAttendant.map(result => (
                                                                    <tr key={result.ID_USUARIO_ORGAO}>
                                                                        <td> </td>
                                                                        <td> {result.NOME_USUARIO} </td>
                                                                        <td> { cpfMask(result.CPF_USUARIO) }</td>
                                                                        <td> { formatDate(result.DATA_INCLUSAO) } </td>
                                                                        <td> {result.DATA_CANCELAMENTO === null ? "-" : formatDate(result.DATA_CANCELAMENTO) } </td>
                                                                        <td> </td>
                                                                    </tr>
                                                                )
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    <PaginationContainer>
                                                        <nav className="br-pagination" aria-label="Paginação de resultados" data-total="50" data-current="1" data-per-page="20">
                                                            <div className="pagination-per-page">
                                                                <label style={{ "fontWeight": "normal", "marginRight": "15px" }}> Exibir </label>
                                                                <SelectPagesContainer>
                                                                    <Select
                                                                        options={rangePagesOptions}
                                                                        defaultValue={{ value: "10", label: "10" }}
                                                                        value={props.rangePagesAttendant}
                                                                        onChange={value => {
                                                                            if (props.searchResultAttendant.filter(e => e.STATUS === 'deleted' || e.STATUS === 'new').length > 0) {
                                                                                props.setModalError(true);
                                                                                props.setMessageError('Existem mudanças não salvas. Por favor, salve as mudanças antes de continuar.');
                                                                            } else {
                                                                                props.setRangePagesAttendant(value)
                                                                                props.onChangePaginationConfigAttendant(value, props.pageAttendant, true)
                                                                            }
                                                                        }}
                                                                        styles={SelecPageStyles}
                                                                        theme={theme => ({
                                                                            ...theme,
                                                                            borderRadius: 6,
                                                                            colors: {
                                                                                ...theme.colors,
                                                                                primary25: '#CCCCCC',
                                                                                primary: '#1351B4'
                                                                            },
                                                                        })}
                                                                        components={
                                                                            {
                                                                                DropdownIndicator,
                                                                                IndicatorSeparator
                                                                            }
                                                                        }
                                                                    />
                                                                </SelectPagesContainer>
                                                            </div>

                                                            <span className="br-divider d-none d-sm-block mx-3"></span>

                                                            <div className="pagination-information d-none d-sm-flex">
                                                                <span className="current"> {1 + ((Number(props.pageAttendant.value) - 1) * Number(props.rangePagesAttendant.value))} </span>&ndash;<span className="per-page"> {Number(props.pageAttendant.value) * Number(props.rangePagesAttendant.value)} </span>&nbsp;de&nbsp;<span className="total"> {props.totalFilterAttendant} </span>&nbsp;itens
                                                            </div>
                                                            <div className="pagination-go-to-page d-none d-sm-flex ml-auto">
                                                                <label style={{ "fontWeight": "normal", "marginRight": "15px" }}> Página </label>
                                                                <SelectPagesContainer>
                                                                    <Select
                                                                        options={props.pageOptionsAttendant}
                                                                        defaultValue={{ value: "1", label: "1" }}
                                                                        value={props.pageAttendant}
                                                                        onChange={value => {
                                                                            if (props.searchResultAttendant.filter(e => e.STATUS === 'deleted' || e.STATUS === 'new').length > 0) {
                                                                                props.setModalError(true);
                                                                                props.setMessageError('Existem mudanças não salvas. Por favor, salve as mudanças antes de continuar.');
                                                                            } else {
                                                                                props.setPageAttendant(value)
                                                                                props.onChangePaginationConfigAttendant(props.rangePagesAttendant, value, false)
                                                                            }
                                                                        }}
                                                                        styles={SelecPageStyles}
                                                                        theme={theme => ({
                                                                            ...theme,
                                                                            borderRadius: 6,
                                                                            colors: {
                                                                                ...theme.colors,
                                                                                primary25: '#CCCCCC',
                                                                                primary: '#1351B4'
                                                                            },
                                                                        })}
                                                                        components={
                                                                            {
                                                                                DropdownIndicator,
                                                                                IndicatorSeparator
                                                                            }
                                                                        }
                                                                    />
                                                                </SelectPagesContainer>
                                                            </div>

                                                            <span className="br-divider d-none d-sm-block mx-3"></span>

                                                            <div className="pagination-arrows ml-auto ml-sm-0">
                                                                <button className="br-button circle" type="button" aria-label="Voltar página"
                                                                    style={{
                                                                        'opacity': Number(props.pageAttendant.value) > 1 ? '' : '0.4',
                                                                        'pointerEvents': Number(props.pageAttendant.value) > 1 ? '' : 'none'
                                                                    }}
                                                                    onClick={() => {
                                                                        if (props.searchResultAttendant.filter(e => e.STATUS === 'deleted' || e.STATUS === 'new').length > 0) {
                                                                            props.setModalError(true);
                                                                            props.setMessageError('Existem mudanças não salvas. Por favor, salve as mudanças antes de continuar.');
                                                                        } else {
                                                                            const new_page = {
                                                                                value: String(Number(props.pageAttendant.value) - 1),
                                                                                label: String(Number(props.pageAttendant.value) - 1)
                                                                            }
                                                                            props.setPageAttendant(new_page)
                                                                            props.onChangePaginationConfigAttendant(props.rangePagesAttendant, new_page, false)
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="fas fa-angle-left" aria-hidden="true">
                                                                        <img
                                                                            src={DropLeftIcon}
                                                                            alt="leftIcon"
                                                                            style={{ "marginBottom": "6px" }}
                                                                        />
                                                                    </i>
                                                                </button>
                                                                <button className="br-button circle" type="button" aria-label="Avançar página"
                                                                    style={{
                                                                        'opacity': Number(props.pageAttendant.value) < (Math.ceil(Number(props.totalFilterAttendant) / Number(props.rangePagesAttendant.value))) ? '' : '0.4',
                                                                        'pointerEvents': Number(props.pageAttendant.value) < (Math.ceil(Number(props.totalFilterAttendant) / Number(props.rangePagesAttendant.value))) ? '' : 'none'
                                                                    }}
                                                                    onClick={() => {
                                                                        if (props.searchResultAttendant.filter(e => e.STATUS === 'deleted' || e.STATUS === 'new').length > 0) {
                                                                            props.setModalError(true);
                                                                            props.setMessageError('Existem mudanças não salvas. Por favor, salve as mudanças antes de continuar.');
                                                                        } else {
                                                                            const new_page = {
                                                                                value: String(Number(props.pageAttendant.value) + 1),
                                                                                label: String(Number(props.pageAttendant.value) + 1)
                                                                            }
                                                                            props.setPageAttendant(new_page)
                                                                            props.onChangePaginationConfigAttendant(props.rangePagesAttendant, new_page, false)
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="fas fa-angle-right" aria-hidden="true">
                                                                        <img
                                                                            src={DropRightIcon}
                                                                            alt="rightIcon"
                                                                            style={{ "marginBottom": "6px" }}
                                                                        />
                                                                    </i>
                                                                </button>
                                                            </div>
                                                        </nav>
                                                    </PaginationContainer>
                                                </>}
                                            </ContentContainer4>
                                        </ContentContainer13>
                                        </>
                                    
                                    }

                                    <span style={{"fontSize": "80%"}}>São obrigatórios os campos marcados com<Mandatory>*</Mandatory></span>
                                </ContentContainer1>
                            </ContentContainer>

                            <ContentContainerButtons>
                                <button className="br-button" type="button"
                                    onClick={() => setModalCancelVisible(true)}>
                                    Voltar
                                </button>

                                {!props.loadingAdd ?
                                    <button className="br-button primary" type="submit">
                                        Confirmar
                                    </button>
                                    :
                                    <button className="br-button primary loading" type="button">
                                        Confirmar
                                    </button>
                                }
                            </ContentContainerButtons>

                        </form>
                    </GlobalContainer>
                </>            
        </>
    );
}